<template>
  <div class="sub_scroll_wrap">
    <div class="width_wrap">
      <div>
        <ul class="scroll_nav">
          <li
            :class="{
              on: $route.path.includes(USER_ROUTES.Product.Testing.Putt.Path),
            }"
          >
            <router-link
              :to="`${USER_ROUTES.Product.Testing.Putt.Path}`"
              alt="PUTT2.0 다중재능검사"
            >
              PUTT2.0 다중재능검사
            </router-link>
          </li>
          <li
            :class="{
              on: $route.path.includes(USER_ROUTES.Product.Testing.Tocc.Path),
            }"
          >
            <router-link
              :to="`${USER_ROUTES.Product.Testing.Tocc.Path}`"
              alt="TOCC창의역량검사"
            >
              TOCC창의역량검사
            </router-link>
          </li>
          <li
            :class="{
              on: $route.path.includes(USER_ROUTES.Product.Testing.Kat.Path),
            }"
          >
            <router-link
              :to="`${USER_ROUTES.Product.Testing.Kat.Path}`"
              alt="KAT지식통각검사"
            >
              KAT지식통각검사
            </router-link>
          </li>
        </ul>
      </div>
      <i class="prev"></i>
      <i class="next"></i>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { USER_ROUTES } from "@/assets/route_constants.ts";
// import { NDropdown } from "naive-ui"; // 현재 템플릿에서 NDropdown이 사용되지 않음
import { useAuth } from "@/composables/useAuth";
const { isLoggedIn } = useAuth();

const store = useStore();
</script>

<style>
.sub_scroll_wrap {
  overflow: hidden;
  height: 39px;
  border-bottom: 1px solid #ccc;
  background: #fff;
}
.sub_scroll_wrap > div {
  position: relative; /*padding: 0 30px;*/
}
.sub_scroll_wrap > div > div {
  overflow-x: scroll;
}
.sub_scroll_wrap > div > div .scroll_nav {
  display: inline-block;
  min-width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
  font-size: 0;
  text-align: center;
  white-space: nowrap;
}
.sub_scroll_wrap > div > div .scroll_nav li {
  display: inline-block;
}
.sub_scroll_wrap > div > div .scroll_nav li a {
  display: inline-block;
  height: 39px;
  line-height: 39px;
  padding: 0 12px;
  font-size: 13px;
  color: #bbb;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  box-sizing: border-box;
  font-weight: 600;
}
.sub_scroll_wrap > div > div .scroll_nav li.on a {
  color: #be7b42;
  font-weight: 600;
}
.sub_scroll_wrap > div i {
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 39px;
}
.sub_scroll_wrap > div i.prev:before {
  content: "";
  position: absolute;
  top: 0;
  left: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-right-color: #333;
}
.sub_scroll_wrap > div i.next {
  right: 0;
  left: inherit;
}
.sub_scroll_wrap > div i.next:before {
  content: "";
  position: absolute;
  top: 0;
  right: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-left-color: #333;
}
@media screen and (min-width: 768px) {
  .sub_scroll_wrap > div i {
    display: none;
  }
}
@media screen and (min-width: 1200px) {
  .sub_scroll_wrap {
    overflow: visible;
    height: auto;
    border-bottom: none;
    background: #fff;
    box-shadow: 3px 3px 3px rgb(0 0 0 / 10%);
  }
  .sub_scroll_wrap > div {
    position: relative;
    padding: 0;
  }
  .sub_scroll_wrap > div > div {
    overflow: hidden;
  }
  .sub_scroll_wrap > div > div .scroll_nav {
    display: table;
    margin: 0;
    width: 100%;
    padding: 0;
    white-space: normal;
    text-align: left;
    border-collapse: collapse;
  }
  .sub_scroll_wrap > div > div .scroll_nav li {
    display: table-cell;
    width: 33%;
    position: relative;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    background: #bbb;
    width: 1px;
    height: 15px;
    margin-top: -7px;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:last-child:after {
    display: none;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:before {
    position: absolute;
    visibility: hidden;
    left: 0;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 3px;
    background: #be7b42;
    content: "";
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: all 0.2s ease-in-out 0s;
    transition: all 0.2s ease-in-out 0s;
    opacity: 0.85;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 60px;
    line-height: 60px;
    padding: 0 5px;
    font-size: 16px;
    text-align: center;
    color: #bbbbbb;
    font-weight: 600;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a:hover {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on a {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on:before,
  .sub_scroll_wrap > div > div .scroll_nav li:hover:before {
    visibility: visible;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}
</style>
